import { Registration } from './registration';
import dompurify from 'dompurify';
const sanitizer = dompurify.sanitize;

//This class will be bound to the edit registration form.
export function RegistrationGroup() {
  this.work = new Registration({ type: 0, vatPercentage: 0.21, vatType: 0 });
  this.travel = new Registration({ type: 2, vatPercentage: 0.21, vatType: 0 });
  this.cost = new Registration({ type: 1, vatPercentage: 0.21, vatType: 0 });

  this.__defineGetter__('group', function() {
    var group = this.work.group;

    if (!group) group = this.travel.group;
    if (!group) group = this.cost.group;

    return group;
  });

  this.__defineGetter__('relation', function() {
    return this.work.relation;
  });
  this.__defineSetter__('relation', function(value) {
    this.work.relation = value;
    this.travel.relation = value;
    this.cost.relation = value;
  });

  this.__defineGetter__('invoiceStreamId', function() {
    return this.work.invoiceStreamId || this.cost.invoiceStreamId || this.travel.invoiceStreamId;
  });
  this.__defineSetter__('invoiceStreamId', function(value) {
    this.work.invoiceStreamId = value;
    this.travel.invoiceStreamId = value;
    this.cost.invoiceStreamId = value;
  });
  this.__defineGetter__('invoiceStream', function() {
    return this.work.invoiceStream || this.cost.invoiceStream || this.travel.invoiceStream;
  });
  this.__defineSetter__('invoiceStream', function(value) {
    this.work.invoiceStream = value;
    this.travel.invoiceStream = value;
    this.cost.invoiceStream = value;
  });

  this.__defineGetter__('remark', function() {
    var remarks = [];
    if (this.work.remark) remarks.push(this.work.remark);
    if (this.travel.remark) remarks.push(this.travel.remark);
    if (this.cost.remark) remarks.push(this.cost.remark);
    if (remarks.length === 0) return '';
    if (remarks.length === 1) return remarks[0];
    return remarks.unique().join('\n');
  });
  this.__defineSetter__('remark', function(value) {
    this.work.remark = value;
    this.travel.remark = value;
    this.cost.remark = value;
  });

  this.__defineGetter__('internalRemark', function() {
    var remarks = [];
    if (this.work.internalRemark) remarks.push(this.work.internalRemark);
    if (this.travel.internalRemark) remarks.push(this.travel.internalRemark);
    if (this.cost.internalRemark) remarks.push(this.cost.internalRemark);
    if (remarks.length === 0) return '';
    if (remarks.length === 1) return remarks[0];
    return remarks.unique().join('\n');
  });
  this.__defineSetter__('internalRemark', function(value) {
    this.work.internalRemark = value;
    this.travel.internalRemark = value;
    this.cost.internalRemark = value;
  });

  this.__defineGetter__('resourceText', function() {
    if (this.work.resource && !this.work.resource.isOther) return this.work.resource.name;
    if (this.work.resourceDescription !== '') return this.work.resourceDescription;
    if (this.cost.resource && !this.cost.resource.isOther) return this.cost.resource.name;
    if (this.cost.resourceDescription !== '') return this.cost.resourceDescription;
    if (this.travel.resource && !this.travel.resource.isOther) return this.travel.resource.name;

    return '';
  });

  this.__defineGetter__('isBillable', function() {
    return this.work.isBillable || this.travel.isBillable || this.cost.isBillable;
  });

  this.__defineGetter__('isBilled', function() {
    return this.work.isBilled || this.travel.isBilled || this.cost.isBilled;
  });

  this.__defineGetter__('hasWork', function() {
    return this.work && this.work.durationMinutes > 0;
  });

  this.__defineGetter__('hasCost', function() {
    return this.cost && this.cost.resource && this.cost.quantity !== 0;
  });
  this.__defineGetter__('date', function() {
    return this.work.date;
  });

  this.__defineSetter__('date', function(value) {
    this.work.date = value;
    this.travel.date = value;
    this.cost.date = value;
  });

  this.__defineGetter__('referenceYear', function() {
    return this.work.referenceYear || this.travel.referenceYear || this.cost.referenceYear;
  });
  this.__defineSetter__('referenceYear', function(value) {
    if (!value || value < 2000) {
      value = null;
    }

    this.work.referenceYear = value;
    this.travel.referenceYear = value;
    this.cost.referenceYear = value;
  });
  this.__defineGetter__('interactionId', function() {
    if (this.work.interactionId !== null) return this.work.interactionId;
    if (this.travel.interactionId !== null) return this.travel.interactionId;
    if (this.cost.interactionId !== null) return this.cost.interactionId;
    return null;
  });
  this.__defineSetter__('interactionId', function(value) {
    this.work.interactionId = value;
    this.travel.interactionId = value;
    this.cost.interactionId = value;
  });
  this.setInteractionType = function(value) {
    this.work.interactionType = value;
    this.travel.interactionType = value;
    this.cost.interactionType = value;
  };
  this.__defineGetter__('interactionType', function() {
    if (this.work.interactionType !== null) return this.work.interactionType;
    if (this.travel.interactionType !== null) return this.travel.interactionType;
    if (this.cost.interactionType !== null) return this.cost.interactionType;
    return null;
  });
  this.__defineSetter__('interactionType', this.setInteractionType);

  this.__defineGetter__('interactionDescription', function() {
    if (this.work.interactionDescription) return this.work.interactionDescription;
    if (this.travel.interactionDescription) return this.travel.interactionDescription;
    if (this.cost.interactionDescription) return this.cost.interactionDescription;

    return null;
  });
  this.__defineGetter__('interactionTitle', function() {
    if (this.work.interactionTitle) return this.work.interactionTitle;
    if (this.travel.interactionTitle) return this.travel.interactionTitle;
    if (this.cost.interactionTitle) return this.cost.interactionTitle;

    return null;
  });
  this.getPlannedTaskIds = function() {
    var result = [];
    if (this.work.plannedTaskId) result.push(this.work.plannedTaskId);
    if (this.work.mainPlannedTaskId) result.push(this.work.mainPlannedTaskId);
    if (this.travel.plannedTaskId) result.push(this.travel.plannedTaskId);
    if (this.travel.mainPlannedTaskId) result.push(this.travel.mainPlannedTaskId);
    if (this.cost.plannedTaskId) result.push(this.cost.plannedTaskId);
    if (this.cost.mainPlannedTaskId) result.push(this.cost.mainPlannedTaskId);
    return result;
  };
  this.clearTaskFields = function() {
    if (this.work) this.work.clearTaskFields();
    if (this.travel) this.travel.clearTaskFields();
    if (this.cost) this.cost.clearTaskFields();
  };
  this.setTaskFields = function(fields) {
    if (this.work) this.work.setTaskFields(fields);
    if (this.travel) this.travel.setTaskFields(fields);
    if (this.cost) this.cost.setTaskFields(fields);
  };
  this.getPlannedTaskId = function() {
    if (this.work.plannedTaskId) return this.work.plannedTaskId;
    if (this.travel.plannedTaskId) return this.travel.plannedTaskId;
    if (this.cost.plannedTaskId) return this.cost.plannedTaskId;
    return null;
  };
  this.hasTask = function() {
    return !!this.getPlannedTaskId();
  };
  this.__defineGetter__('taskName', function() {
    if (this.work.taskName) return this.work.taskName;
    if (this.travel.taskName) return this.travel.taskName;
    if (this.cost.taskName) return this.cost.taskName;

    return null;
  });

  this.setInteractionTypeAfterChange = function() {
    const hasValue = !!(this.interactionDescription || this.interactionTitle);
    if (hasValue && this.interactionType === null) {
      this.setInteractionType(0);
    } else if (!hasValue && this.interactionType !== null) {
      this.setInteractionType(null);
    }
  };
  this.setInteractionDescription = function(value) {
    // old interactions were created without HTML markup. In order to render them in our rich text editors, replace the newlines with break lines
    if (value && !value.includes('<html>')) {
      value = value.replace(/\n/g, '<br />');
      value = sanitizer(value);
    }

    this.work.interactionDescription = value;
    this.travel.interactionDescription = value;
    this.cost.interactionDescription = value;
    if (typeof value !== 'undefined') this.setInteractionTypeAfterChange();
  };
  this.__defineSetter__('interactionDescription', this.setInteractionDescription);

  this.setInteractionTitle = function(value) {
    this.work.interactionTitle = value;
    this.travel.interactionTitle = value;
    this.cost.interactionTitle = value;
    if (typeof value !== 'undefined') this.setInteractionTypeAfterChange();
  };
  this.__defineSetter__('interactionTitle', this.setInteractionTitle);

  this.initDate = function(value) {
    var date = null;
    if (this.work.group) date = this.work.date;
    if (!date && this.travel.group) date = this.travel.date;
    if (!date && this.cost.group) date = this.cost.date;
    if (!date) date = value;

    this.work.date = date;
    this.travel.date = date;
    this.cost.date = date;
  };
  this.setRelation = function() {
    var relation = this.work.relation;
    if (!relation) relation = this.travel.relation;
    if (!relation) relation = this.cost.relation;

    if (!this.work.relation) this.work.relation = relation;
    if (!this.travel.relation) this.travel.relation = relation;
    if (!this.cost.relation) this.cost.relation = relation;

    var invoiceStreamId = this.invoiceStreamId;
    if (invoiceStreamId) {
      if (!this.work.invoiceStreamId) this.work.invoiceStreamId = invoiceStreamId;
      if (!this.travel.invoiceStreamId) this.travel.invoiceStreamId = invoiceStreamId;
      if (!this.cost.invoiceStreamId) this.cost.invoiceStreamId = invoiceStreamId;
    }
    var invoiceStream = this.invoiceStream;
    if (!invoiceStream && invoiceStreamId && relation && relation.invoiceStreams) {
      //Get invoicestream from array in relation
      invoiceStream = relation.invoiceStreams.find(x => x.id === invoiceStreamId);
    }
    if (invoiceStream) {
      if (!this.work.invoiceStream) this.work.invoiceStream = invoiceStream;
      if (!this.travel.invoiceStream) this.travel.invoiceStream = invoiceStream;
      if (!this.cost.invoiceStream) this.cost.invoiceStream = invoiceStream;
    }
  };
  this.setInteractionInfo = function(data) {
    if (!data) return;
    if (data instanceof RegistrationGroup || data instanceof Registration) {
      if (!data.interactionId || data.group !== this.group) return;
      //Copy from other registration
      this.interactionId = data.interactionId;
      this.setInteractionType(data.interactionType);
      this.interactionTitle = data.interactionTitle;
      this.interactionDescription = data.interactionDescription;
      return;
    }

    if (
      data.objectId &&
      data.id &&
      (data.title || data.description) &&
      data.objectId === this.group
    ) {
      //InteractionDTO response
      this.interactionId = data.id;
      this.setInteractionType(data.interactionType);
      this.interactionTitle = data.title;
      this.interactionDescription = data.description;
    }
  };

  this.setUser = function(userId, userName) {
    this.work.userId = userId;
    this.travel.userId = userId;
    this.cost.userId = userId;
    if (userName) {
      this.work.user = userName;
      this.travel.user = userName;
      this.cost.user = userName;
    }
  };
  this.setResourceName = function(resourceNameFilter) {
    this.work.setResourceName(resourceNameFilter);
    this.travel.setResourceName(resourceNameFilter);
    this.cost.setResourceName(resourceNameFilter);
  };
  this.translate = function($filter) {
    this.work.translate($filter);
    this.travel.translate($filter);
    this.cost.translate($filter);
  };

  this.setPart = function(part) {
    if (!part || !part.resource) {
      console.warn('RegistrationGroup.setPart: part not provided or without resource.');
      return;
    }

    switch (part.resource.type) {
      case 1:
        this.cost.set(part);
        break;
      case 2:
        this.travel.set(part);
        break;
      default:
        this.work.set(part);
        break;
    }
  };

  this.toJson = function(pretty) {
    return angular.toJson(
      {
        work: this.work,
        travel: this.travel,
        cost: this.cost,
      },
      !!pretty,
    );
  };

  this.fromJson = function(json) {
    var reg = angular.fromJson(json);
    if (!reg) return;
    if (reg.work) this.work.set(reg.work);
    if (reg.travel) this.travel.set(reg.travel);
    if (reg.cost) this.cost.set(reg.cost);
  };

  this.validate = function() {
    var w = this.work.validate();
    var c = this.cost.validate();
    var t = this.travel.validate();

    return w && c && t; //Make sure all three are called.
  };

  //Split group into separate registrations
  this.getRegistrationsWithId = function() {
    const result = [];
    if (this.work && this.work.id) result.push(this.work);
    if (this.cost && this.cost.id) result.push(this.cost);
    if (this.travel && this.travel.id) result.push(this.travel);
    return result;
  };
}
